export const authConfig = {
    // URL ezID
    CLIENT_ID: 'ezInvoice',
    SCOPES: 'openid profile email',
    RESPONSE_TYPE: 'id_token token',
    REDIRECT_URI: `${window.location.origin}/callback`,
    LOGOUT_REDIRECT_URI: `${window.location.origin}/logout`,
}